module.exports = __webpack_public_path__ + "static/media/Box_green.728bf92a.png";